// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import {
  FilterItem as StyledFilterItem,
  CloseButton,
  UpperCase
} from "../styles";
import { processColumnNames } from "src/constants/display";
import * as colors from "src/styles/constants/colors";
import Icon from "src/icons";

type Props = {
  value: any,
  column: string,
  handleClose: Function
};

const Parent = ({ value, column, handleClose }: Props) => {
  return (
    <StyledFilterItem>
      <span>
        {processColumnNames[column]}
        {i18n.t(k._)}
      </span>
      <UpperCase>{value}</UpperCase>
      <CloseButton onClick={handleClose}>
        <Icon type="close" color={colors.active} />
      </CloseButton>
    </StyledFilterItem>
  );
};

export default Parent;
